/**
 * Systemstatus und Speicherplatzverwaltung (§20.4, §32).
 *
 * Diese Antwort ist ausdrücklich **nicht** der Healthcheck aus §35.2: Der ist öffentlich, nennt
 * nur vier Ja/Nein-Werte und wird vom Container abgefragt. Der Systemstatus hier verlangt eine
 * Administratorsitzung und geht ins Einzelne.
 *
 * Was hier trotzdem nie erscheint (§20.4): Geheimnisse, vollständige Umgebungsvariablen und
 * absolute Pfade. Ein Pfad verrät die Verzeichnisstruktur des Servers und hilft bei der Bedienung
 * nicht weiter — die Verzeichnisse werden über ihre Rolle benannt.
 */
export const SYSTEMSTATUS_PATH = '/api/v1/admin/systemstatus';
export const BETRIEBSHINWEISE_PATH = '/api/v1/admin/hinweise';
/** Pfad des vollständigen Zurücksetzens (ÄA-3). */
export const ZURUECKSETZEN_PATH = '/api/v1/admin/systemstatus/zuruecksetzen';
export const VERZEICHNISZUSTAND_BESCHRIFTUNG = {
    lesbar_schreibbar: 'lesbar und beschreibbar',
    nur_lesbar: 'nur lesbar',
    fehlt: 'fehlt oder nicht zugänglich',
};
export const VERZEICHNISROLLE_BESCHRIFTUNG = {
    daten: 'Datenverzeichnis',
    backups: 'Backupverzeichnis',
    exporte: 'Exportverzeichnis',
    protokolle: 'Protokollverzeichnis',
};
//# sourceMappingURL=systemstatus.js.map